import styled from 'styled-components'
import { Avatar } from 'antd'

export const StyledAvatar = styled(Avatar)`
  & > img {
    width: 32px;
    object-fit: contain;
  }
`
